'use strict';

var promisify = require('promisify-es6');

var once = require('once');

var CID = require('cids');

var SendOneFile = require('../utils/send-one-file');

module.exports = function (send) {
  var sendOneFile = SendOneFile(send, 'object/patch/set-data');
  return promisify(function (cid, data, opts, _callback) {
    if (typeof opts === 'function') {
      _callback = opts;
      opts = {};
    }

    var callback = once(_callback);

    if (!opts) {
      opts = {};
    }

    try {
      cid = new CID(cid);
    } catch (err) {
      return callback(err);
    }

    sendOneFile(data, {
      args: [cid.toString()]
    }, function (err, result) {
      if (err) {
        return callback(err);
      }

      callback(null, new CID(result.Hash));
    });
  });
};